import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { store } from '../../../redux/oldStore';
import { ServerResponse } from '../../../utils/Server';
import Icon, { IconType } from '../../Icon/Icon';
import Modal from '../../Modal/Modal';
import { ICaptainAssignment, ICategoryCaptainInfo } from './CategoryCaptainTypes';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import Button from '../../_Core/Button';

interface ICategoryCaptainManagerProps {}

interface IForm {
  Assignment: ICaptainAssignment;
}

interface ISpecialForm {
  awardId?:number;
  personId?:number;
}

const CategoryCaptainManager = (props: ICategoryCaptainManagerProps) => {
  const [data, setData] = useState<ICategoryCaptainInfo>();
  const [userDic, setUserDic] = useState<any>({});
  const [divDic, setDivDic] = useState<any>({});
  const [selectedAssignment, setSelectedAssignment] = useState<ICaptainAssignment>();
  const [form, setForm] = useState<IForm>({ Assignment: {} });
  const [showEditor, setShowEditor] = useState<boolean>(false);
  const [specialForm, setSpecialForm] = useState<ISpecialForm>({});
  const [showSpecialAwardEditor, setShowSpecialAwardEditor] = useState<boolean>(false);



  useEffect(() => {
    init();
  }, []);

  useEffect(() => {
    setForm({ ...form, Assignment: selectedAssignment ?? {} });
  }, [selectedAssignment]);

  const init = () => {
    store.server.getApi<ServerResponse<ICategoryCaptainInfo>>('../JudgingCaptain/Info').then((x) => {
      if (x.Success) {
        setData(x.Value);
        let dic = {};
        x.Value.judges.forEach((j) => {
          dic[j.id] = j.name;
        });

        let dd = {};
        x.Value.divisions.forEach((d) => {
          dd[d.id] = d.name;
        });
        setDivDic(dd);
        setUserDic(dic);
      } else {
        toast.error(x.Message, { autoClose: false });
      }
    });
  };

  const addAssignment = () => {
    let request = form.Assignment ?? {};

    let errors: string[] = [];
    if (!request.CategoryId) errors.push('Category');
    if (!request.PersonId) errors.push('Captain');
    if (!request.DivisionId) request.DivisionId = 0;

    if (errors.length > 0) {
      toast.warning(
        <>
          You are missing some required information:
          <ul>
            {errors.map((e) => {
              return <li>{e}</li>;
            })}
          </ul>
        </>,
      );
      return;
    }
    store.server.postApi<ServerResponse<any>>('../JudgingCaptain/AddCaptain/', request).then((x) => {
      if (x.Success) {
        init();
        setSelectedAssignment(undefined);
        setForm({ ...form, Assignment: selectedAssignment ?? {} });
        toast.info('Captain added!');
      } else {
        toast.error(x.Message, { autoClose: false });
      }
    });
  };
  const removeAssignment = (id: number) => {
    if (window.confirm(`Are you sure you want to remove this captain?`)) {
      store.server.getApi<ServerResponse<any>>('../JudgingCaptain/RemoveCaptain/' + id).then((x) => {
        if (x.Success) {
          init();
          setSelectedAssignment(undefined);
          setForm({ ...form, Assignment: selectedAssignment ?? {} });
          toast.info('Captain removed!');
        } else {
          toast.error(x.Message, { autoClose: false });
        }
      });
    }
  };


  const addSpecialAssignment = () => {
    let request = specialForm;

    let errors: string[] = [];
    if (!request.awardId) errors.push('Award');
    if (!request.personId) errors.push('Captain');

    if (errors.length > 0) {
      toast.warning(
        <>
          You are missing some required information:
          <ul>
            {errors.map((e) => {
              return <li>{e}</li>;
            })}
          </ul>
        </>,
      );
      return;
    }
    store.server.postApi<ServerResponse<any>>('../JudgingCaptain/SpecialAwardCaptainAdd/', request).then((x) => {
      if (x.Success) {
          init();
        setSpecialForm({});
        setShowSpecialAwardEditor(false);
        toast.info('Captain added!');
      } else {
        toast.error(x.Message, { autoClose: false });
      }
    });
  };
  const removeSpecialAssignment = (award:ISpecialForm) => {
    if (window.confirm(`Are you sure you want to remove this captain?`)) {
      store.server.postApi<ServerResponse<any>>('../JudgingCaptain/SpecialAwardCaptainRemove/', award).then((x) => {
        if (x.Success) {
          init();
          setSpecialForm({});
          setShowSpecialAwardEditor(false);
          toast.info('Captain removed!');
        } else {
          toast.error(x.Message, { autoClose: false });
        }
      });
    }
  };


  return (
    <>
      <Tabs>
        <TabList>
          <Tab>Category Captains</Tab>
          <Tab>Special Award Captains</Tab>
        </TabList>
        <TabPanel>
          <div className="">
            <h4>Category Captains (Chairs)</h4>
            You can assign users that can help manage your categories.
            <hr />
            <div className="catagory-chair-container-list">
              {data &&
                data.categories.map((c, ci) => {
                  return (
                    <div className="category-chair-container" key={`ccc-${ci}`}>
                      <div className="flex-between">
                        <strong>{c.name}</strong>

                        <button
                          type="button"
                          className="btn btn-xs btn-default"
                          onClick={() => {
                            setShowEditor(true);
                            let f = { ...form };
                            f.Assignment.CategoryId = +c.id;
                            setForm(f);
                          }}>
                          <Icon type={IconType.plus} /> Add Captain
                        </button>
                      </div>
                      <div className="category-chair-captains">
                        {data.captains
                          .filter((x) => x.CategoryId === +c.id)
                          .map((a, ai) => {
                            return (
                              <div key={`cap-${ai}`} className="category-chair-cap">
                                <span
                                  className="click text-danger"
                                  onClick={() => {
                                    removeAssignment(a.Id ?? 0);
                                  }}>
                                  <Icon type={IconType.trashO} />
                                </span>
                                &nbsp;&nbsp;&nbsp;
                                {userDic[a.PersonId ?? 0] ?? 'Unknown'}
                                {divDic[a.DivisionId ?? 0] && (
                                  <>
                                    <span className="text-muted">
                                      &nbsp;&nbsp;&nbsp;
                                      {divDic[a.DivisionId ?? 0]}
                                    </span>
                                  </>
                                )}
                              </div>
                            );
                          })}
                      </div>
                    </div>
                  );
                })}
            </div>
          </div>
        </TabPanel>
        <TabPanel>
          <div>
            <h4>Special Award Captains</h4>

            <hr />
            {data && (!data.specialAwards || data.specialAwards.length === 0) && <div>
                <div className='alert alert-info'>
                  <h5>No Special Awards</h5>
                  There are not speical awards defined.
                </div>
              </div>}
            {data && <>
              <div className='item-list'>
                {data.specialAwards.map((x,i)=>{
                    let judges = data.specialAwardCaptainDic[x.id+''] ?? [];
                  return (
                    <div key={`sa-${i}`} className='list-item'>
                      <div className='flex-between'>
                        <h6>{x.name}</h6> 
                        <div>

                        <button
                          type="button"
                          className="btn btn-xs btn-default"
                          onClick={() => {
                            setShowSpecialAwardEditor(true);
                            let f = { ...specialForm, awardId: +x.id };
                            setSpecialForm(f);
                          }}>
                          <Icon type={IconType.plus} /> Add Captain
                        </button>

                        </div>
                      </div>

                        {judges.length > 0 ? <div>{judges.map((j, ji)=>{
                            let judge = data.judgesDic[j+''];
                          return (
                            <div key={`judge-${i}-${ji}`} className='flex'>
                              <Button type='remove' iconOnly={true} onClick={()=>{removeSpecialAssignment({awardId:+x.id, personId:+j})}} />
                              {judge.FirstName} {judge.LastName} {judge.Email}</div>
                          );
                        })}</div> : 
                          <div>
                            <span className='label label-warning'>No captains assigned.</span>
                          </div>
                        }
                      </div>
                  );
                })}
              </div>
            </>}
          </div>
        </TabPanel>
      </Tabs>

      {showEditor && (
        <Modal setModalOpen={setShowEditor} title={`Assign Judging Captain`} size={'m'}>
          <div className="form-horizontal">
            <div className="form-group">
              <label className="control-label col-sm-4" htmlFor="cc-category">
                Category
              </label>
              <div className="col-sm-8">
                <select
                  id="cc-category"
                  className="form-control"
                  value={form.Assignment.CategoryId ?? 0}
                  onChange={(e) => {
                    let f = { ...form };
                    f.Assignment.CategoryId = +e.target.value;
                    setForm(f);
                  }}>
                  <option value={0}>Select</option>
                  {data?.categories.map((x, i) => {
                    return (
                      <option key={`cc-c-${i}`} value={x.id}>
                        {x.name}
                      </option>
                    );
                  })}
                </select>
              </div>
            </div>
            <div className="form-group">
              <label className="control-label col-sm-4" htmlFor="cc-judge">
                Captain
              </label>
              <div className="col-sm-8">
                <select
                  id="cc-judge"
                  className="form-control"
                  value={form.Assignment.PersonId ?? 0}
                  onChange={(e) => {
                    let f = { ...form };
                    f.Assignment.PersonId = +e.target.value;
                    setForm(f);
                  }}>
                  <option value={0}>Select</option>
                  {data?.judges.map((x, i) => {
                    return (
                      <option key={`cc-j-${i}`} value={x.id}>
                        {x.name}
                      </option>
                    );
                  })}
                </select>
              </div>
            </div>
            <div className="form-group">
              <label className="control-label col-sm-4" htmlFor="cc-division">
                Division
              </label>
              <div className="col-sm-8">
                <select
                  id="cc-division"
                  className="form-control"
                  value={form.Assignment.DivisionId ?? 0}
                  onChange={(e) => {
                    let f = { ...form };
                    f.Assignment.DivisionId = +e.target.value;
                    setForm(f);
                  }}>
                  <option value={0}>Select</option>
                  {data?.divisions.map((x, i) => {
                    return (
                      <option key={`cc-d-${i}`} value={x.id}>
                        {x.name}
                      </option>
                    );
                  })}
                </select>
              </div>
            </div>
            <div className="form-group">
              <div className="col-sm-8 col-sm-offset-4">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => {
                    addAssignment();
                  }}>
                  <Icon type={IconType.save} /> Save
                </button>
                <button
                  type="button"
                  className="btn btn-default"
                  onClick={() => {
                    setShowEditor(false);
                  }}>
                  <Icon type={IconType.close} /> Close
                </button>
              </div>
            </div>
          </div>
        </Modal>
      )}

      {showSpecialAwardEditor && (
        <Modal setModalOpen={setShowSpecialAwardEditor} title={`Assign Special Award Captain`} size={'m'}>
          <div className="form-horizontal">
            <div className="form-group">
              <label className="control-label col-sm-4" htmlFor="sa-award">
                Award
              </label>
              <div className="col-sm-8">
                <select
                  id="sa-category"
                  className="form-control"
                  value={specialForm.awardId ?? 0}
                  onChange={(e) => {
                    let f = { ...specialForm };
                    f.awardId = +e.target.value;
                    setSpecialForm(f);
                  }}>
                  <option value={0}>Select</option>
                  {data?.specialAwards.map((x, i) => {
                    return (
                      <option key={`sa-c-${i}`} value={x.id}>
                        {x.name}
                      </option>
                    );
                  })}
                </select>
              </div>
            </div>
            <div className="form-group">
              <label className="control-label col-sm-4" htmlFor="sa-judge">
                Captain
              </label>
              <div className="col-sm-8">
                <select
                  id="sa-judge"
                  className="form-control"
                  value={specialForm.personId ?? 0}
                  onChange={(e) => {
                    let f = { ...specialForm };
                    f.personId = +e.target.value;
                    setSpecialForm(f);
                  }}>
                  <option value={0}>Select</option>
                  {data?.judges.map((x, i) => {
                    return (
                      <option key={`sa-j-${i}`} value={x.id}>
                        {x.name}
                      </option>
                    );
                  })}
                </select>
              </div>
            </div>
            <div className="form-group">
              <div className="col-sm-8 col-sm-offset-4">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => {
                    addSpecialAssignment();
                  }}>
                  <Icon type={IconType.save} /> Save
                </button>
                <button
                  type="button"
                  className="btn btn-default"
                  onClick={() => {
                    setShowSpecialAwardEditor(false);
                  }}>
                  <Icon type={IconType.close} /> Close
                </button>
              </div>
            </div>
          </div>
        </Modal>
      )}
    </>
  );
};

export default CategoryCaptainManager;
